import { IDetailStory } from "@/types/constants";

export const DetailCard: IDetailStory = {
    key: "1",
    title: "Sông Băng Tận Thế, Ta Trữ Hàng Chục Tỷ Vật Tư",
    description:
        "Ngàn vạn năm trước, Lý Thất Dạ trồng xuống một cây Thúy Trúc.Tám trăm vạn năm trước, Lý Thất Dạ nuôi một đầu cá chép.Năm trăm vạn năm trước, Lý Thất Dạ thu dưỡng một cái tiểu cô nương.... ... ... ... ...Hôm nay, Lý Thất Dạ tỉnh lại sau giấc ngủ, Thúy Trúc tu luyện thành thần linh, cá chép hóa thành Kim Long, tiểu cô nương trở thành Cửu Giới Nữ Đế.Đây là một cái dưỡng thành cố sự, một cái bất tử Nhân tộc tiểu tử dưỡng thành Yêu Thần, dưỡng thành Tiên thú, dưỡng thành Nữ Đế cố sự. ",
    author: "Nguyễn Văn Thoại",
    category: "Huyền Huyễn",
    image: "https://cdn-4.ohay.tv/imgs/38e64b454ef64e288e6d/728.jpg",
    time: "10 phút trước",
    chapName: "Chương 114: Thu phục Hắc Mạc, đỉnh tiêm thế lực nội tình",
    quantityRead: 205,
    rating: 5.0,
};
export const desDetail =
    'Đám học đồ mỗi ngày đều làm từng bước rời giường, luyện công, làm việc.<br><br>Thời gian bị sắp xếp tràn đầy.<br><br>Bất quá, tất cả học đồ nhưng không có một người gọi mệt mỏi, từng cái đều cắn răng, kìm nén một cỗ kình luyện Đại Hà Tráng Huyết Công.<br><br>Chỉ là, liên tiếp mấy ngày đều không có nghe nói ai đem Đại Hà Tráng Huyết Công đã luyện thành.<br><br>Lục Trường Sinh cũng nghe được Đại Hà Tráng Huyết Công một chút tình huống.<br><br>Muốn tăng tốc tiến độ, hoàn toàn chính xác có biện pháp, đó chính là dược thiện.<br><br>Nếu là mỗi ngày bồi bổ chuyên môn dược thiện, Đại Hà Tráng Huyết Công tiến độ liền có thể rất nhanh.<br><br>Thế nhưng là, dược thiện sẽ chỉ cung cấp cho đội hộ vệ, nơi nào sẽ cho phổ thông học đồ?<br><br>Về phần mình mua sắm, vậy thì càng đừng suy nghĩ.<br><br>Phổ thông học đồ lại không có tiền công, trên thân một đồng tiền đều không có, đi nơi nào mua sắm dược thiện?<br><br>Trong nháy mắt, thời gian trôi qua mười một ngày.<br><br>Một ngày này, Lục Trường Sinh các loại học đồ mới vừa tới đến quảng trường, liền nghe đến một tên học đồ chủ động mở miệng nói: "Lưu lão, ta. . . Ta giống như cảm ứng được khí huyết."<br><br>"Ừm? Tới ta xem một chút."<br><br>Lưu lão ánh mắt sáng lên.<br><br>Sau đó, một tên dáng người cao gầy học đồ đi tới Lưu lão trước mặt, đưa tay ra.<br><br>Lưu lão cầm học đồ tay, sau đó nhắm mắt lại.<br><br>"Không sai, hoàn toàn chính xác nhập môn."<br><br>"Có thể mười một ngày liền nhập môn, tư chất coi như không tệ."<br><br>"Tốt, từ hôm nay trở đi, ngươi không cần làm tạp dịch học đồ công việc, trực tiếp đi đội hộ vệ, mỗi ngày dùng dược thiện luyện công, hiệu quả sẽ tốt hơn."<br><br>"A. . . Tạ ơn Lưu lão."<br><br>Học đồ này không gì sánh được hưng phấn.<br><br>Hắn muốn đi đội hộ vệ, sau này sẽ là cường đại võ giả . Chờ võ công có sở thành, dù gì cũng có thể làm cái Diệu Thủ viên hộ vệ, cùng phổ thông tạp dịch học đồ đó là trời và đất khác nhau.<br><br>"Tốt, đi đội hộ vệ đi."<br><br>Lưu lão khoát tay áo, ánh mắt của hắn lại nhìn lướt qua đông đảo học đồ, liền vừa cười vừa nói: "Đều thấy được? Chỉ cần trong một tháng có thể luyện thành Đại Hà Tráng Huyết Công, liền có thể đi đội hộ vệ, đối với các ngươi tới nói tương đương với một bước lên trời!"<br><br>Đám học đồ xao động.<br><br>Bọn hắn nhìn xem vừa rồi cái kia học đồ, trong lòng không gì sánh được lửa nóng.<br><br>"Vừa rồi cái kia học đồ là Triệu Nhị chó a?"<br><br>"Triệu Nhị gan chó con rất nhỏ, tại học đồ bên trong cũng là bị khi phụ người, lần này phát đạt';

export const fontValues = [
    {
        label: "Roboto",
        key: "Roboto",
    },
    {
        label: "Times New Roman",
        key: "Times New Roman",
    },
    {
        label: "Open Sans",
        key: "Open Sans",
    },
    {
        label: "Nunito Sans",
        key: "Nunito Sans",
    },
    {
        label: "Oxygen",
        key: "Oxygen",
    },
    {
        label: "Signika Negative",
        key: "Signika Negative",
    },
    {
        label: "Cantarell",
        key: "Cantarell",
    },

    {
        label: "Tahoma",
        key: "Tahoma",
    },
    {
        label: "Arial",
        key: "Arial",
    }, // {
    //     label: "Palatino Linotype",
    //     key: "Palatino Linotype",
    // },
    // {
    //     label: "Source Sans Pro",
    //     key: "Source Sans Pro",
    // },
    // {
    //     label: "Segoe UI",
    //     key: "Segoe UI",
    // },
    // {
    //     label: "Patrick Hand",
    //     key: "Patrick Hand",
    // },
    // {
    //     label: "Noticia Text",
    //     key: "Noticia Text",
    // },
    // {
    //     label: "Verdana",
    //     key: "Verdana",
    // },
];
